import React, { useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import InputAdornment from '@mui/material/InputAdornment'
import CloseIcon from '@mui/icons-material/Close'
import DnsIcon from '@mui/icons-material/Dns'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

const emptyServer = { name: '', ip: '', atlanteURL: '', SFTPURL: '', usernameSFTP: '', passwordSFTP: '' }

export const ServerDialog = ({ open, onClose, onSave, servers = [], isSiapAdmin, editData }) => {
  const isCreateMode = !editData
  const [server, setServer] = useState(emptyServer)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (!open) return
    if (isCreateMode) {
      setServer(emptyServer)
    } else {
      const found = servers.find(({ _id }) => _id === editData?.serverId)
      setServer(found || emptyServer)
    }
  }, [open, editData, servers, isCreateMode])

  const handleFieldChange = (field) => (e) => {
    setServer((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleServerSelect = (e) => {
    const selected = servers.find(({ _id }) => _id === e.target.value)
    if (selected) setServer(selected)
  }

  const handleSave = () => {
    onSave(server, isCreateMode)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      aria-labelledby='server-dialog-title'
    >
      <DialogTitle
        id='server-dialog-title'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <DnsIcon color='primary' />
          <Typography variant='h6' component='span' fontWeight={600}>
            {isCreateMode ? 'Nuovo Server' : 'Dati Server'}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size='small' aria-label='Chiudi'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2.5 }}>
        <Stack spacing={2.5}>
          {isCreateMode
            ? (
              <TextField
                label='Nome'
                size='small'
                fullWidth
                value={server?.name || ''}
                onChange={handleFieldChange('name')}
                disabled={!isSiapAdmin}
                aria-label='Nome server'
              />
              )
            : (
              <FormControl size='small' fullWidth>
                <InputLabel id='server-select-label'>Server</InputLabel>
                <Select
                  labelId='server-select-label'
                  value={server?._id || ''}
                  onChange={handleServerSelect}
                  label='Server'
                  disabled={!isSiapAdmin}
                >
                  {servers.map((s) => (
                    <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              )}

          <TextField
            label='IP'
            size='small'
            fullWidth
            value={server?.ip || ''}
            onChange={handleFieldChange('ip')}
            disabled={!isSiapAdmin}
            aria-label='Indirizzo IP server'
          />

          <TextField
            label='Atlante URL'
            size='small'
            fullWidth
            value={server?.atlanteURL || ''}
            onChange={handleFieldChange('atlanteURL')}
            disabled={!isSiapAdmin}
            aria-label='URL Atlante'
          />

          <TextField
            label='SFTP URL'
            size='small'
            fullWidth
            value={server?.SFTPURL || ''}
            onChange={handleFieldChange('SFTPURL')}
            disabled={!isSiapAdmin}
            aria-label='URL SFTP'
          />

          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <TextField
              label='User SFTP'
              size='small'
              fullWidth
              value={server?.usernameSFTP || ''}
              onChange={handleFieldChange('usernameSFTP')}
              disabled={!isSiapAdmin}
              aria-label='Username SFTP'
            />
            <TextField
              label='Password SFTP'
              size='small'
              fullWidth
              type={showPassword ? 'text' : 'password'}
              value={server?.passwordSFTP || ''}
              onChange={handleFieldChange('passwordSFTP')}
              disabled={!isSiapAdmin}
              aria-label='Password SFTP'
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge='end'
                        size='small'
                        aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                        tabIndex={0}
                      >
                        {showPassword ? <VisibilityOff fontSize='small' /> : <Visibility fontSize='small' />}
                      </IconButton>
                    </InputAdornment>
                  )
                }
              }}
            />
          </Box>
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          size='small'
          sx={{ textTransform: 'none' }}
        >
          Annulla
        </Button>
        {isSiapAdmin && (
          <Button
            onClick={handleSave}
            variant='contained'
            size='small'
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Salva
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
